<template>
  <div class="sus-container">
    <h1 class="main-title">
      <span>
        {{ $t("sustainableReport.csrTitle") }}
        <hr/>
      </span>
    </h1>
    <div class="box">
      <div class="box-row">
        <div class="content-box">
          <h2><span>{{ mptList[$i18n.locale].csrtitle1 }}</span></h2>
          <div class="button-box">
            <a :href="mptList[$i18n.locale].csrUrl1" class="button-a" :download="mptList[$i18n.locale].csrtitle1" target="_blank">{{ mptList[$i18n.locale].btn}} PDF</a>
          </div>
        </div>
        <div class="content-box">
          <h2><span>{{ mptList[$i18n.locale].csrtitle2 }}</span></h2>
          <div class="button-box">
            <a :href="mptList[$i18n.locale].csrUrl2" class="button-a" :download="mptList[$i18n.locale].csrtitle2" target="_blank">{{ mptList[$i18n.locale].btn}} PDF</a>
          </div>
        </div>
        <div class="content-box">
          <h2><span>{{ mptList[$i18n.locale].csrtitle3 }}</span></h2>
          <div class="button-box">
            <a :href="mptList[$i18n.locale].csrUrl3" class="button-a" :download="mptList[$i18n.locale].csrtitle3" target="_blank">{{ mptList[$i18n.locale].btn}} PDF</a>
          </div>
        </div>
        <div class="content-box">
          <h2><span>{{ mptList[$i18n.locale].csrtitle4 }}</span></h2>
          <div class="button-box">
            <a :href="mptList[$i18n.locale].csrUrl4" class="button-a" :download="mptList[$i18n.locale].csrtitle4" target="_blank">{{ mptList[$i18n.locale].btn}} PDF</a>
          </div>
        </div>
        <div class="content-box">
          <h2><span>{{ mptList[$i18n.locale].csrtitle5 }}</span></h2>
          <div class="button-box">
            <a :href="mptList[$i18n.locale].csrUrl5" class="button-a" :download="mptList[$i18n.locale].csrtitle5" target="_blank">{{ mptList[$i18n.locale].btn}} PDF</a>
          </div>
        </div>
        <div class="content-box">
          <h2><span>{{ mptList[$i18n.locale].csrtitle6 }}</span></h2>
          <div class="button-box">
            <a :href="mptList[$i18n.locale].csrUrl6" class="button-a" :download="mptList[$i18n.locale].csrtitle6" target="_blank">{{ mptList[$i18n.locale].btn}} PDF</a>
          </div>
        </div>
      </div>
    </div>
    <div class="column-logo">
      <img src="../../assets/logo_white.png" alt="">
    </div>
    <h1 class="main-title">
      <span>
        {{ $t("sustainableReport.zcTitle") }}
        <hr/>
      </span>
    </h1>
    <div class="box">
      <div class="box-row">
        <div class="content-box">
          <h2><span>{{ mptList[$i18n.locale].title2 }}</span></h2>
          <div class="button-box" >
            <a :href="mptList[$i18n.locale].zcUrl1" :download="mptList[$i18n.locale].zcUrl1Name" class="button-a" target="_blank">{{ mptList[$i18n.locale].btn}} PDF</a>
          </div>
        </div>
        <div class="content-box">
          <h2><span>{{ mptList[$i18n.locale].title3 }}</span></h2>
          <div class="button-box" >
            <a :href="mptList[$i18n.locale].zcUrl2" :download="mptList[$i18n.locale].zcUrl2Name" class="button-a" target="_blank">{{ mptList[$i18n.locale].btn}} PDF</a>
          </div>
        </div>
        <div class="content-box">
          <h2><span>{{ mptList[$i18n.locale].title4 }}</span></h2>
          <div class="button-box" >
            <a :href="mptList[$i18n.locale].zcUrl3" :download="mptList[$i18n.locale].zcUrl3Name" class="button-a" target="_blank">{{ mptList[$i18n.locale].btn}} PDF</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mptList: {
        EN: {
          btn:"Download",
          csrUrl1:"../../static/pdf/2016_csr_en.pdf",
          csrUrl2:"../../static/pdf/2017_csr_en.pdf",
          csrUrl3:"../../static/pdf/2018_csr_en.pdf",
          csrUrl4:"../../static/pdf/2019_csr_en.pdf",
          csrUrl5:"../../static/pdf/2020_csr_en.pdf",
          csrUrl6:"../../static/pdf/2021_csr_en.pdf",
          csrtitle1: "CSR Report(2016)",
          csrtitle2: "CSR Report(2017)",
          csrtitle3: "CSR Report(2018)",
          csrtitle4: "CSR Report(2019)",
          csrtitle5: "CSR Report(2020)",
          csrtitle6: "CSR Report(2021)",
          zcUrl1:"../../static/pdf/MPTZfile.pdf",
          zcUrl2:"../../static/pdf/MPTKfile.pdf",
          zcUrl3:"../../static/pdf/MPTVfile.pdf",
          zcUrl1Name:"MPTZ反貪腐暨洗錢防制聲明",
          zcUrl2Name:"MPTK反貪腐暨洗錢防制聲明",
          zcUrl3Name:"MPTV反貪腐暨洗錢防制聲明",
          title2: "CSR Related Policies(MPTZ)",
          title3: "CSR Related Policies(MPTK)",
          title4: "CSR Related Policies(MPTV)",
        },
        CN: {
          btn:"下载",
          csrUrl1:"../../static/pdf/2016_csr_zh.pdf",
          csrUrl2:"../../static/pdf/2017_csr_zh.pdf",
          csrUrl3:"../../static/pdf/2018_csr_zh.pdf",
          csrUrl4:"../../static/pdf/2019_csr_zh.pdf",
          csrUrl5:"../../static/pdf/2020_csr_zh.pdf",
          csrUrl6:"../../static/pdf/2021_csr_zh.pdf",
          csrtitle1: "CSR报告书(2016)",
          csrtitle2: "CSR报告书(2017)",
          csrtitle3: "CSR报告书(2018)",
          csrtitle4: "CSR报告书(2019)",
          csrtitle5: "CSR报告书(2020)",
          csrtitle6: "CSR报告书(2021)",
          zcUrl1:"../../static/pdf/MPTZfile.pdf",
          zcUrl2:"../../static/pdf/MPTKfile.pdf",
          zcUrl3:"../../static/pdf/MPTVfile.pdf",
          zcUrl1Name:"MPTZ反貪腐暨洗錢防制聲明",
          zcUrl2Name:"MPTK反貪腐暨洗錢防制聲明",
          zcUrl3Name:"MPTV反貪腐暨洗錢防制聲明",
          title2: "政策与宣言(MPTZ)",
          title3: "政策与宣言(MPTK)",
          title4: "政策与宣言(MPTV)",
        },
        CHT: {
          btn:"下载",
          csrUrl1:"../../static/pdf/2016_csr_zh.pdf",
          csrUrl2:"../../static/pdf/2017_csr_zh.pdf",
          csrUrl3:"../../static/pdf/2018_csr_zh.pdf",
          csrUrl4:"../../static/pdf/2019_csr_zh.pdf",
          csrUrl5:"../../static/pdf/2020_csr_zh.pdf",
          csrUrl6:"../../static/pdf/2021_csr_zh.pdf",
          csrtitle1: "CSR報告書(2016)",
          csrtitle2: "CSR報告書(2017)",
          csrtitle3: "CSR報告書(2018)",
          csrtitle4: "CSR報告書(2019)",
          csrtitle5: "CSR報告書(2020)",
          csrtitle6: "CSR報告書(2021)",
          zcUrl1:"../../static/pdf/MPTZfile.pdf",
          zcUrl2:"../../static/pdf/MPTKfile.pdf",
          zcUrl3:"../../static/pdf/MPTVfile.pdf",
          zcUrl1Name:"MPTZ反貪腐暨洗錢防制聲明",
          zcUrl2Name:"MPTK反貪腐暨洗錢防制聲明",
          zcUrl3Name:"MPTV反貪腐暨洗錢防制聲明",
          title2: "政策與宣言(MPTZ)",
          title3: "政策與宣言(MPTK)",
          title4: "政策與宣言(MPTV)",
        },
        JP: {
          btn:"ダウンロード",
          csrUrl1:"../../static/pdf/2016_csr_en.pdf",
          csrUrl2:"../../static/pdf/2017_csr_en.pdf",
          csrUrl3:"../../static/pdf/2018_csr_en.pdf",
          csrUrl4:"../../static/pdf/2019_csr_en.pdf",
          csrUrl5:"../../static/pdf/2020_csr_en.pdf",
          csrUrl6:"../../static/pdf/2021_csr_en.pdf",
          csrtitle1: "CSR報告書(2016)",
          csrtitle2: "CSR報告書(2017)",
          csrtitle3: "CSR報告書(2018)",
          csrtitle4: "CSR報告書(2019)",
          csrtitle5: "CSR報告書(2020)",
          csrtitle6: "CSR報告書(2021)",
          zcUrl1:"../../static/pdf/MPTZfile.pdf",
          zcUrl2:"../../static/pdf/MPTKfile.pdf",
          zcUrl3:"../../static/pdf/MPTVfile.pdf",
          zcUrl1Name:"MPTZ反貪腐暨洗錢防制聲明",
          zcUrl2Name:"MPTK反貪腐暨洗錢防制聲明",
          zcUrl3Name:"MPTV反貪腐暨洗錢防制聲明",
          title2: "政策と宣言(MPTZ)",
          title3: "政策と宣言(MPTK)",
          title4: "政策と宣言(MPTV)",
        },
      },
    };
  },
};
</script>

<style scoped>
.box{
  max-width: 80rem;
  margin: 2rem auto;
}
.column-logo{
  background:#00457A;
  padding:40px;
  margin: 0rem auto;
}
.column-logo img{
  max-width: 100%;
  height: auto;
  width: 12rem;
  display: block;
  margin:auto;
}
.box-row{
  text-align: left;
  color:#00457A;
}
.content-box{
  padding-bottom: 1rem;
  border-bottom: 2px solid #f3f3f3;
  display: flex;
}
.box-row h2{
  padding: 1rem 0;
  color:#00457A;
  text-align: left;
  min-width: 80%;
}
.button-box{
  padding-top: 1rem;
}
.button-a{
  display: inline-block;
  margin: 3px;
  white-space: nowrap;
  line-height: 4rem;
  border: none;
  padding: 0rem 2rem;
  letter-spacing: 2px;
  text-decoration: none;
  font-size: 1.5rem;
  border-radius: 0.5rem;
  color: #fff;
  background: #29aae1;
}
@media (max-width: 767px) {
  .box{
    width: 100%;
    margin: 1rem auto;
    padding: 0 0.5rem;
  }
  .column-logo img{
    width: 6rem;
  }
  .box-row{
    text-align: left;
    color:#00457A;
  }
  .content-box{
    padding-bottom: 0rem;
    border-bottom: 2px solid #f3f3f3;
    display: block;
  }
  .box-row h2{
    padding: 1rem 0;
    color:#00457A;
    text-align: left;
    min-width: 45%;
    font-size: 1.3rem;
  }
  .button-box{
    padding-top: 0rem;
    padding-bottom: 1rem;
    text-align: right;
  }
  .button-a{
    display: inline-block;
    margin: 3px;
    white-space: nowrap;
    line-height: 1.5rem;
    border: none;
    padding: 0.5rem 1rem;
    letter-spacing: 2px;
    text-decoration: none;
    font-size: 1rem;
    border-radius: 0.5rem;
    color: #fff;
    background: #29aae1;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Company/SustainableReport.vue